import { BreadcrumbArray, PrimaryFullScreenSpinner } from "@repo/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { AdminPageContainer } from "~/components/layout/AdminPageContainer";
import { AdminPageHeader } from "~/components/layout/AdminPageHeader";
import { opsHead } from "~/head";

export const Route = createFileRoute("/__auth/operations")({
  head: () => opsHead("Operations"),
  component: () => (
    <Suspense fallback={<PrimaryFullScreenSpinner />}>
      <View />
    </Suspense>
  ),
});

function View() {
  return (
    <AdminPageContainer fullWidth>
      <AdminPageHeader
        contextLine={
          <BreadcrumbArray
            stack={[
              {
                title: "Operations",
                to: "/operations",
              },
            ]}
          />
        }
        title="Operations"
      />
      <Outlet />
    </AdminPageContainer>
  );
}
